import { currencyFormat } from "./FormatHelper";


export function sumCosts(attributes, fields, costFields) {
  var summedCosts = 0;
  for (var i = 0; i < costFields.length; i++) {
    if (costFields[i] === fields.estimatedTotalCost || costFields[i] === fields.contributedTotalCost) {
      continue;
    }

    const attributeName = costFields[i];
    const attributeValue = attributes[attributeName]?.toString().replaceAll(",", "");

    const lineItemCost = (attributeValue && !isNaN(attributeValue)) ? parseFloat(attributeValue) : 0;
    summedCosts += lineItemCost;
  }
  return parseInt(summedCosts).toFixed(0);
}

export function sumCostsMultiFunding(assetCost, grantsCost, contractualCost, otherCost, personnelCost) {
  const assetCostValue = assetCost?.toString().replaceAll(",", "");
  const grantsCostValue = grantsCost?.toString().replaceAll(",", "");
  const contractualCostValue = contractualCost?.toString().replaceAll(",", "");
  const otherCostValue = otherCost?.toString().replaceAll(",", "");
  const personnelCostValue = personnelCost?.toString().replaceAll(",", "");
  const numericAssetCostValue = (assetCostValue && !isNaN(assetCostValue)) ? parseFloat(assetCostValue) : 0;
  const numericGrantsCostValue = (grantsCostValue && !isNaN(grantsCostValue)) ? parseFloat(grantsCostValue) : 0;
  const numericContractualCostValue = (contractualCostValue && !isNaN(contractualCostValue)) ? parseFloat(contractualCostValue) : 0;
  const numericOtherCostValue = (otherCostValue && !isNaN(otherCostValue)) ? parseFloat(otherCostValue) : 0;
  const numericPersonnelCostValue = (personnelCostValue && !isNaN(personnelCostValue)) ? parseFloat(personnelCostValue) : 0;
  const lineItemTotalCost = numericAssetCostValue + numericContractualCostValue + numericGrantsCostValue + numericOtherCostValue + numericPersonnelCostValue;
  const totalCost = parseInt(lineItemTotalCost).toFixed(0);
  return currencyFormat(totalCost);
}
